const SIDEBAR_COLLECTION = "SIDEBAR_COLLECTION";
const SIDEBAR_COLLECTION_SUCCESS = "SIDEBAR_COLLECTION_SUCCESS";
const SIDEBAR_COLLECTION_FAIL = "SIDEBAR_COLLECTION_FAIL";

const SUBMIT = "SUBMIT";
const SUBMIT_SUCCESS = "SUBMIT_SUCCESS";
const SUBMIT_FAIL = "SUBMIT_FAIL";

export default function sidebarCollection(
  state = {
    data: [],
    isLoading: true,
    hasErrored: false,
    message: "",
    isSubmitting: false,
  },
  action,
) {
  switch (action.type) {
    case SIDEBAR_COLLECTION: {
      return Object.assign({}, state, {
        isLoading: true,
        hasErrored: false,
      });
    }

    case SIDEBAR_COLLECTION_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        message: action.error.message,
        hasErrored: true,
      });
    }

    case SIDEBAR_COLLECTION_SUCCESS: {
      return Object.assign({}, state, {
        data: action.payload.data?.data,
        paths: action.payload.data?.paths,
        isLoading: false,
        hasErrored: false,
      });
    }

    case SUBMIT: {
      return Object.assign({}, state, {
        isSubmitting: true,
      });
    }

    case SUBMIT_SUCCESS: {
      return Object.assign({}, state, {
        isSubmitting: false,
      });
    }

    case SUBMIT_FAIL: {
      return Object.assign({}, state, {
        isSubmitting: false,
        message: action.payload.message,
      });
    }
    default:
      return state;
  }
}

export function getCollectionItems() {
  return {
    type: SIDEBAR_COLLECTION,
    payload: {
      request: {
        url: "Collection",
      },
    },
  };
}

export function addOrEditCollection(Collections) {
  // let list = [
  //   { id: 4, parentId: 117, delete: true, childrenId: 3 },
  //   { id: 0, parentId: 117, delete: true, childrenId: 52 },
  //   { id: 5, parentId: 117, delete: true, childrenId: 21 },
  // ];

  return {
    type: SUBMIT,
    payload: {
      request: {
        url: "Collection/AddOrEdit",
        method: "POST",
        data: Collections,
      },
      options: {
        onSuccess({ dispatch }) {
          dispatch(getCollectionItems());
        },
      },
    },
  };
}

export function deleteCollection(id) {
  return {
    type: SUBMIT,
    payload: {
      request: {
        url: "Collection/" + id,
        method: "DELETE",
      },
      options: {
        onSuccess({ dispatch }) {
          dispatch(getCollectionItems());
        },
      },
    },
  };
}
